const mediaItems = [
  {
    id: 1,
    title: '本周娱乐圈大事件盘点',
    desc: '五分钟带你回顾本周最劲爆的娱乐新闻与明星动态，精彩不容错过。',
    duration: '05:32',
    views: '12.8万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20style%20with%20dramatic%20spotlight%20on%20a%20dark%20stage%2C%20warm%20coral%20and%20golden%20lighting%20effects%2C%20entertainment%20news%20aesthetic%2C%20professional%20broadcast%20look%2C%20dynamic%20composition%20with%20play%20button%20design%20element&width=800&height=450&seq=media-01-weekly&orientation=landscape',
  },
  {
    id: 2,
    title: '明星街拍穿搭大赏',
    desc: '当红明星最新街拍造型全收录，时尚穿搭灵感一网打尽。',
    duration: '08:15',
    views: '9.6万',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20street%20style%20editorial%20with%20warm%20natural%20lighting%20and%20urban%20backdrop%2C%20soft%20coral%20and%20cream%20tones%2C%20magazine%20quality%20photography%20style%2C%20elegant%20casual%20composition%20with%20city%20vibe&width=800&height=450&seq=media-02-fashion&orientation=landscape',
  },
  {
    id: 3,
    title: '热播剧大结局深度解析',
    desc: '年度热播剧大结局全解读，剧情分析、隐藏彩蛋与粉丝神评论合集。',
    duration: '12:40',
    views: '18.3万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20analysis%20scene%20with%20warm%20theater%20lighting%20and%20dramatic%20curtain%20reveal%2C%20soft%20golden%20and%20coral%20ambient%20glow%2C%20movie%20review%20aesthetic%2C%20elegant%20storytelling%20visual%20with%20classic%20cinema%20elements&width=800&height=450&seq=media-03-drama&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">精彩内容</h2>
          <p className="text-foreground-600 text-sm md:text-base">热门视频图文内容精选，随时随地轻松浏览</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative w-full aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                    if (el.parentElement) el.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-background-50 text-xs">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center gap-3 text-foreground-500 text-xs">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {item.duration}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}